import Brand from '@/services/Brand';

export default {
	state: {
		permissions: null,
		policyNum: '',
		cleintId: '',
		riskResourcesRequested: false,
		reportsRequested: false,
	},
	getters: {
		permissions: (state) => state.permissions,
		policyNum: (state) => state.policyNum,
		clientId: (state) => state.clientId,
		riskResourcesRequested: (state) => state.riskResourcesRequested,
		reportsRequested: (state) => state.reportsRequested,
	},
	mutations: {
		setPermissions: (state, permissions) => {
			state.permissions = permissions;
		},
		setPolicyNum: (state, policyNum) => {
			state.policyNum = policyNum;
		},
		setClientId: (state, clientId) => {
			state.clientId = clientId;
		},
		setRiskResourcesRequested: (state, riskResourcesRequested) => {
			state.riskResourcesRequested = riskResourcesRequested;
		},
		setReportsRequested: (state, reportsRequested) => {
			state.reportsRequested = reportsRequested;
		},
	},
	actions: {
		setupPermissions: (context, payload) => {
			context.commit('setPermissions', payload);
		},
		setupPolicyNum: (context, payload) => {
			context.commit('setPolicyNum', payload);
		},
		setupClientId: (context, payload) => {
			context.commit('setClientId', payload);
		},
		setupRiskResourcesRequested: (context, payload) => {
			context.commit('setRiskResourcesRequested', payload);
		},
		setupReportsRequested: (context, payload) => {
			context.commit('setReportsRequested', payload);
		},
	},
};
